export default __webpack_public_path__ + "static/car_seat_icon_gray-c78e32918aadf50c78fd0d69f19aab30.png";